const tipoIdiomaList = [
    {
        id: 'pt-br', // HARDCODEBACKEND.tipoIdiomaPtBr
        descricao: 'Português Brasil',
        indTraducao: 0,
        ordem: 10,
    },
    {
        id: 'pt-pt', // HARDCODEBACKEND.tipoIdiomaPtPt
        descricao: 'Português Portugal',
        indTraducao: 1,
        ordem: 20,
    },
    {
        id: 'en-us', // HARDCODEBACKEND.tipoIdiomaEnUs
        descricao: 'Inglês',
        indTraducao: 2,
        ordem: 30,
    },
    {
        id: 'es-es', // HARDCODEBACKEND.tipoIdiomaEsEs
        descricao: 'Espanhol',
        indTraducao: 3,
        ordem: 40,
    },
]

export default tipoIdiomaList